import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
export function InviteMemberLocked({ reason }) {
    const { t } = useTranslation('glossary');
    return (<Tooltip>
            <TooltipTrigger asChild>
                <Button variant="outline" className="gap-2" disabled>
                    <Lock className="h-4 w-4"/>
                    {t('workspaces.invite_member.locked_button')}
                </Button>
            </TooltipTrigger>
            <TooltipContent>
                <p>{t(`workspaces.invite_member.locked_tooltip_${reason}`)}</p>
            </TooltipContent>
        </Tooltip>);
}
